import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { XmlRequest } from '../../../../models/api-xml-2/xml-2/xml-2-request.model';
import { Xml2Service } from '../../../../services/api-xml/xml-2/xml-2.service';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { FALSE, TRUE } from '../../../../utils/config/const';
import {RouteExtService} from "../../../../helpers/route-ext";
import {XmlRedService} from "../../../../services/api-xml/xml-red/xml-red.service";
import {ActivityMapEditComponent} from "../../custompage/activity-map/activity-map-edit/activity-map-edit.component";
import {DIALOG_LARGE_CONFIG} from "../../../../utils/config/modal-settings";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ModalResultXmlRedComponent} from "../../custompage/modal-result-xml-red/modal-result-xml-red.component";
import {XmlRedResponse} from "../../../../models/api-xml-2/xml-2/xml-2-response.model";

@Component({
  selector: 'app-load-xml',
  templateUrl: './load-xml.component.html',
  styleUrls: ['./load-xml.component.css']
})
export class LoadXmlComponent implements OnInit {

  formBuilder: FormGroup;
  xmlModel: XmlRequest;
  files: File[] = [];
  filesSRC: any;
  acceptFileType: string[] = [
    "text/xml",
  ];
  xmlRed = false;


  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private xml2Service: Xml2Service,
    private xmlRedService: XmlRedService,
    private spinnerService: SpinnerService,
    private routerExt: RouteExtService,
    private modalService: NgbModal
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.xmlModel = new XmlRequest();

    if (this.routerExt.getCurrentUrl() === '/xml-red') {
      this.xmlRed = true;
    }
  }

  initForm() {
    this.formBuilder = this.fb.group({
      filename: ['', [Validators.required]],
    });
  };

  get form() { return this.formBuilder; }
  get formControls() { return this.formBuilder.controls; }

  onFileDropped(event) {
    this.fileChange(event);
  }

  onFileChange(event) {
    let files = event.target.files;
    this.fileChange(files);
  }

  fileChange(files) {
    if (files && files.length) {
      this.files = files;
      let fileType = this.files[0].type;
      let fileSize = this.files[0].size;
      let fileTypeIsCorrect = false;
      let size = false;
      // Controllo se il file è inferiore a 10mb (in bytes)
      if (fileSize <= 10485760) {
        size = true;
      }

      // Controllo se il file ha un formato corretto
      for (let obj of this.acceptFileType) {
        if (obj === fileType) { fileTypeIsCorrect = true; }
      }

      if (fileTypeIsCorrect === TRUE && size === TRUE) {
        this.successLoadFile(files);
      } else {
        this.errorLoadFile(size);
      }
    }
  }

  successLoadFile(files) {
    let reader = new FileReader();
    const [file] = files;

    this.formBuilder.controls['filename'].setValue(this.files[0].name);

    reader.readAsBinaryString(file);
    reader.onload = () => {
      this.filesSRC = reader.result;
    }
  }

  errorLoadFile(size) {
    if (size === FALSE) {
      this.toastr.error('Si è verificato un errore durante il caricamento', 'Il file che stai cercando di caricare è troppo grande', {
        timeOut: 5000
      });
    } else {
      this.toastr.error('Si è verificato un errore durante il caricamento', 'Il file che stai cercando di caricare non è un XML', {
        timeOut: 5000
      });
    }
    this.formBuilder.controls['filename'].setValue('');
    this.files = [];
  }

  save() {
    this.xmlModel = this.formBuilder.value;
    this.spinnerService.show();

    if(this.routerExt.getCurrentUrl() === '/xml-red'){
      this.xmlRedService.import(this.files[0]).subscribe(
          (response: XmlRedResponse) => {
            if (response && typeof response != typeof undefined) {
              this.spinnerService.hide();
              this.openModal(response)
              this.toastr.success('Xml importato con successo!', 'Importazione Xml');
            }
          }
      );

    }else{
      this.xml2Service.import(this.files[0]).subscribe(
          (response) => {
            if (response != null && typeof response != typeof undefined) {
              this.spinnerService.hide();
              this.toastr.success('Xml importato con successo!', 'Importazione Xml');

            }
          }
      );
    }



  }
  cancel() {
    // Resetto il form
    this.formBuilder.reset();
    // Recupero l'input utilizzando l'id
    let file = document.getElementById('fileUpload') as HTMLInputElement;
    // Resetto il value dell'input
    file.value = '';
  }

  openModal(response: XmlRedResponse){
    const modalRef = this.modalService.open(ModalResultXmlRedComponent);
    modalRef.componentInstance.data = response;
    modalRef.result.then(result => {
      this.cancel()
    });
  }

  exportXlsx(): void {
    this.spinnerService.show();

    this.xmlRedService.export().subscribe({
      next: (blob: Blob) => {
        if (blob) {

          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.download = `stores_${new Date().toISOString()}.xlsx`;
          anchor.click();
          window.URL.revokeObjectURL(url);
          this.toastr.success('File Excel scaricato con successo!', 'Download completato');
        }
      },
      error: (error) => {
        console.error('Errore durante il download del file:', error);
        this.toastr.error('Si è verificato un errore durante il download.', 'Errore');
      },
      complete: () => {
        this.spinnerService.hide();
      },
    });
  }

}
